<div class="container-fluid" dir="rtl">
  <div *ngIf="isLoading" class="text-center my-5"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">در حال بارگذاری...</span></div><p class="mt-2">در حال بارگذاری فعالیت ماهانه تأمین سرمایه...</p></div>
  <div *ngIf="error && !isLoading" class="alert alert-danger text-center" role="alert"><i class="fas fa-exclamation-triangle me-2"></i>{{ error }}<button type="button" class="btn btn-outline-danger btn-sm ms-3" (click)="goBack()">بازگشت</button></div>
  <div *ngIf="reportData && !isLoading" class="capital-supply-monthly-activity-detail">
    <div class="header-section card mb-4">
      <div class="card-header bg-secondary text-white"><h4 class="mb-0"><i class="fas fa-coins me-2"></i>جزئیات فعالیت ماهانه تأمین سرمایه</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6"><p><strong>نماد:</strong> {{ reportData.symbol }} <span *ngIf="reportData.isin">({{ reportData.isin }})</span></p></div>
          <div class="col-md-6"><p><strong>سال مالی:</strong> {{ reportData.fiscalYear | persianNumber }}</p><p *ngIf="reportData.reportMonth"><strong>ماه گزارش:</strong> {{ reportData.reportMonth | persianNumber }}</p></div>
        </div>
        <div *ngIf="reportData.uri" class="mt-2"><a [href]="reportData.uri" target="_blank" class="btn btn-sm btn-outline-primary"><i class="fas fa-external-link-alt me-1"></i>مشاهده در سامانه کدال</a></div>
      </div>
    </div>
    <div class="section-card card mb-4" *ngIf="reportData.items?.length">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-list me-2"></i>اقلام فعالیت ماهانه</h5></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" style="font-size: 0.85rem;">
            <thead class="table-dark">
              <tr>
                <th>بخش</th>
                <th>شرح</th>
                <th class="text-end">از ابتدای سال تا پایان دوره قبل</th>
                <th class="text-end">اصلاح‌شده</th>
                <th class="text-end">طی دوره یک‌ماهه</th>
                <th class="text-end">جمع تا پایان دوره جاری</th>
                <th class="text-end">جمع سال مالی قبل</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.items">
                <td>{{ sectionLabel(item.section) }}</td>
                <td>{{ item.description }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.column1))" tooltipClass="tooltip-class">{{ formatNumber(item.column1) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.column2))" tooltipClass="tooltip-class">{{ formatNumber(item.column2) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.column3))" tooltipClass="tooltip-class">{{ formatNumber(item.column3) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.column4))" tooltipClass="tooltip-class">{{ formatNumber(item.column4) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.column5))" tooltipClass="tooltip-class">{{ formatNumber(item.column5) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-4"><button type="button" class="btn btn-secondary" (click)="goBack()"><i class="fas fa-arrow-right me-2"></i>بازگشت به لیست</button></div>
  </div>
</div>
